import { create } from "zustand";

export type PolicyViewMode = "structured" | "raw";

type AgentPolicyUiState = {
  viewMode: PolicyViewMode;
  setViewMode: (mode: PolicyViewMode) => void;
};

export const useAgentPolicyUiStore = create<AgentPolicyUiState>((set) => ({
  viewMode: "structured",
  setViewMode: (mode) => set({ viewMode: mode }),
}));
